// resources/js/components/StartpageContent.js

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import '/css/app.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import p_schuette_in_disp from '/images/Schuetten-in-Displays.webp';
import p_disp_in_cont from '/images/Schuetten-Displays-in-Container.webp';

export default function QualityContent() {
    return (
        <div className="row d-flex justify-content-center">
            <div className="col-md-9">
                <div>
                    <h1 className="text-center mt-3">Quality</h1>
                </div>
                <div>
                    <h4 className="text-center mt-3">A little about our quality</h4>
                </div>
                <div className='d-flex flex-row align-items-center'>
                
                    <div className='row'>
                        <div className='col-sm-3 col-9'>
                            <img src={p_schuette_in_disp} className="h-auto mw-100"/> {/* w-75 me-4 my-3 */}
                        </div>
                        <div className='col-sm-9'>
                            <p>Our display boxes have been tried, tested and technically designed to ensure exceptional durability. 
                            For additional security all corners are protected as well as the display being fully boxed for shipment.</p>
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-row align-items-center'>
                    <p>Besides we optimized the container loading. One HC container takes 50 of our displays, leaving no wasted space. 
                    Thus, avoiding any movement and subsequently there is no damage to the displays and merchandise.</p>
                </div>
                <div className='d-flex flex-row align-items-center'>
                    
                    <div className='row'>
                        <div className='col-sm-6 col-9'>
                            <img src={p_disp_in_cont} className="h-auto mw-100"/> {/* w-75 me-4 my-3 */}
                        </div>
                        <div className='col-sm-6'>
                            <p>After container loading, our customers are provided with a complete packing report of the displays as well 
                            as a loading report of the containers. This way we ensure overall transparency.</p>
                            <p>The high-quality plastic pallets have been chosen to be durable and aesthetically pleasing to complete the 
                            look for direct instore placement.</p>
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-row align-items-center'>
                    <p>Prior to this, all the actual items are fully compliant and tested against EU-parameters and EU-requirements. 
                    It is part of our service to make sure that our items can be sold worldwide without raising any issues.
                    </p>
                </div>
                <div className='d-flex flex-row align-items-center mb-4'>
                    <p>
                    Not only are the items compliant against the strictest regulations, but also the conditions under which they were produced 
                    are fully monitored. We take human and environmental protection seriously and follow-up the situation in the manufacturing 
                    sites on a regular basis. For this we are a proud member of amfori BSCI and committed to all the ethical obligations. 
                    To learn more about amfori BSCI, click here: <a href="https://www.amfori.org/content/amfori-bsci" target="_blank">amfori</a></p>
                </div>
            
            </div>
        </div>
    );
}

if (document.getElementById('quality-content')) {
    const container = document.getElementById('quality-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<QualityContent />);
}